import React from 'react';
import { Neighbours } from '../components/Neighbours';
import { UserRatings } from 'utils/entities';

interface StatsSectionProps {
  userRatings: { [rating in UserRatings]?: number | boolean };
}

export const StatsSection: React.FC<StatsSectionProps> = ({ userRatings }) => {
  if (!userRatings) return null;
  return (
    <Neighbours userRatings={userRatings} />
  );
};
